import { Checkbox, createStyles, Group, Stack } from '@mantine/core';
import type { ClassifierCategory } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import type { CreatePolicyStore } from './CreatePolicyStore';

export interface PiiClassifierOption {
	label: string;
	value: ClassifierCategory;
	checked: boolean;
}

const useStyles = createStyles((theme) => ({
	root: {
		flexDirection: 'row',
		gap: theme.other.space[1],
	},
}));

export const PiiClassifierOptions = observer(
	({
		store,
		options,
		index,
	}: {
		store: CreatePolicyStore;
		options: PiiClassifierOption[];
		index: number;
	}) => {
		const { classes } = useStyles();

		return (
			<Stack w="49%">
				{options.map(({ label, checked, value }) => (
					<Group key={label} className={classes.root}>
						<Checkbox
							size="sm"
							key={label}
							checked={checked}
							onChange={() =>
								store.setPIIClassifierBoolean(index, value, !checked)
							}
						/>
						<Text size="sm" weight="regular">
							{label}
						</Text>
					</Group>
				))}
			</Stack>
		);
	}
);
